import styled, { css } from 'styled-components';
import { Button } from '~/ui/components';

type MessageButtonProps = {
  disabled?: boolean;
};

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-block: 24px;
  padding-inline: 12px;
  gap: 12px;
`;

export const TopSection = styled.div`
  display: flex;
  justify-content: end;

  button {
    width: fit-content;
  }
`;

export const MessageButton = styled(Button)<MessageButtonProps>`
  ${({ disabled, theme }) =>
    disabled &&
    css`
      color: ${theme.colors.element.secondary};

      svg {
        color: ${theme.colors.element.secondary};
      }

      &:hover {
        cursor: not-allowed;
      }
    `}
`;
export const ExpandeButton = styled(Button)`
  min-width: 24px;
  min-height: 24px;

  svg {
    width: 14px;
    height: 14px;
  }
`;

export const Code = styled.b`
  cursor: pointer;
  color: ${({ theme }) => theme.colors.brand.primary};
`;

export const DateContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const CommentsWrapper = styled.div`
  margin-top: 15px;
  max-height: calc(100vh - 95px);
  overflow: scroll;

  &::-webkit-scrollbar {
    width: 4px;
  }
`;
